import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { PaginationControlsDirective } from 'ngx-pagination';

@Component({
  selector: 'txtb-documents-paginator',
  templateUrl: './documents-paginator.component.html',
  styleUrls: ['./documents-paginator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DocumentsPaginatorComponent {
  @Output() pageChange = new EventEmitter<number>();

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }

  onPrev(pagination: PaginationControlsDirective): void {
    pagination.isFirstPage()
      ? pagination.setCurrent(pagination.getLastPage())
      : pagination.previous();
  }

  onNext(pagination: PaginationControlsDirective): void {
    pagination.isLastPage() ? pagination.setCurrent(1) : pagination.next();
  }
}
